import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    showPromotionalCard: true,
    graphStatistics: null,
    stats: null,
};

export const homeSlice = createSlice({
    name: 'home',
    initialState,
    reducers: {
        setShowPromotionalCard: (state, action) => {
            state.showPromotionalCard = action.payload;
        },

        setGraphStatistics: (state, action) => {
            state.graphStatistics = action.payload;
        },

        setStats: (state, action) => {
            state.stats = action.payload;
        },
    },
});

export const { setShowPromotionalCard, setGraphStatistics, setStats } = homeSlice.actions;

export default homeSlice.reducer;
